module.exports = __webpack_public_path__ + "static/img/3.7ee86a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/2/3.png
// module id = 4tXY
// module chunks = 1